import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { GlobalService } from './../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var ChangeLogService = /** @class */ (function () {
    function ChangeLogService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'eqcpcc': this._global.find(_GlobalNS.paths.eqcpcc)
            })
        };
    }
    ChangeLogService.prototype.getChangeLogData = function (requestparms, paginationParams) {
        var _this = this;
        var api = _GlobalNS.api.auction.changeLog;
        var params = new HttpParams().set('LoanNumber', requestparms.loanNumber)
            .set('changedBy', requestparms.changedBy)
            .set('dateFrom', requestparms.dateFrom)
            .set('dateTo', requestparms.dateTo)
            .set('RecordOffset', paginationParams.offset.toString())
            .set('PageRecords', paginationParams.pageSize.toString())
            .set('SortDir', paginationParams.sortDir.toString())
            .set('SortValue', paginationParams.sortValue.toString())
            .delete('changedBy', '')
            .delete('LoanNumber', '')
            .delete('dateFrom', '')
            .delete('dateTo', '');
        this.httpOptions['params'] = params;
        return this._http.get("" + api, this.httpOptions)
            .pipe(map(function (response) { return _this.formatChangeLogData(response); }), catchError(function (error) { return throwError(error); }));
    };
    ChangeLogService.prototype.formatChangeLogData = function (res) {
        var formattedData = res;
        formattedData.data = this.getData(res);
        return formattedData;
    };
    ChangeLogService.prototype.getData = function (res) {
        var changeLogItems = [];
        res.data.map(function (item) {
            var tempdata;
            tempdata = {
                auctionUpdateHistoryID: item.AuctionUpdateHistoryID,
                initialReservePricePercentageOld: item.InitialReservePricePercentageOld !== null ? Number(item.InitialReservePricePercentageOld.toFixed(2)) : item.InitialReservePricePercentageOld,
                initialReservePricePercentageNew: item.InitialReservePricePercentageNew,
                UpdateStatusValue: item.UpdateStatusValue,
                reservePriceOld: item.ReservePriceOld,
                reservePriceNew: item.ReservePriceNew,
                reservePriceReductionPercentageOld: item.ReservePriceReductionPercentageOld !== null ? Number(item.ReservePriceReductionPercentageOld.toFixed(2)) : item.ReservePriceReductionPercentageOld,
                reservePriceReductionPercentageNew: item.ReservePriceReductionPercentageNew,
                loanNumber: item.LoanNumber,
                changeDate: item.UpdateDate,
                changedBy: item.UpdateOperatorName
            };
            changeLogItems.push(tempdata);
        });
        return changeLogItems;
    };
    ChangeLogService.prototype.getChangeLogDataSelectors = function () {
        var _this = this;
        var api = _GlobalNS.api.auction.changeLogSelectors;
        return this._http.get("" + api)
            .pipe(map(function (response) { return _this.formatSelectors(response); }), catchError(function (error) { return throwError(error); }));
    };
    ChangeLogService.prototype.formatSelectors = function (res) {
        var data = {
            loans: this.getLoans(res.data[0].Loan),
            changedBy: this.getChangedByUsers(res.data[0].ChangedBy)
        };
        return data;
    };
    ChangeLogService.prototype.getLoans = function (data) {
        var loans = [];
        var tempArray = {};
        data.map(function (items) {
            tempArray = {
                name: items.LoanNumber,
                code: items.LoanNumber
            };
            loans.push(tempArray);
        });
        return loans;
    };
    ChangeLogService.prototype.getChangedByUsers = function (data) {
        var changedBy = [];
        var tempArray = {};
        data.map(function (items) {
            tempArray = {
                name: items.ChangedByName,
                code: items.ChangedById
            };
            changedBy.push(tempArray);
        });
        return changedBy;
    };
    ChangeLogService.ngInjectableDef = i0.defineInjectable({ factory: function ChangeLogService_Factory() { return new ChangeLogService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: ChangeLogService, providedIn: "root" });
    return ChangeLogService;
}());
export { ChangeLogService };
